import React from "react";
import { Box } from "@mui/material";
import Footer from "./Footer/Footer";
import styles from "./MainPageLayoutStyle";
import { Outlet, useLocation } from "react-router-dom";
import ResponsiveAppBar from "./Navbar/ResponsiveAppBar";
import useScrollToTop from "../hooks/useScrollToTop";

const MainPageLayout = () => {
  const location = useLocation();
  // Use the scroll to top hook
  useScrollToTop();

  // Check if the current URL has a query parameter for step=9
  const searchParams = new URLSearchParams(location.search);
  const isCompletedStep =
    location.pathname === "/post-job" && searchParams.get("step") === "9";

  const propertyOwnersSwitch = [
    { id: "h", label: "Homeowners", link: "/homeowners" },
    { id: "l", label: "Landlords", link: "/landlords" },
    { id: "s", label: "Short Term Rental Hosts", link: "/short-term-rentals" },
  ];

  const getPropertyOwnersDropdown = () => {
    return propertyOwnersSwitch;
  };

  const navItems = {
    general: [
      {
        id: 1,
        type: "link",
        label: "Property Owners",
        dropdown: true,
        dropdownItems: getPropertyOwnersDropdown(),
      },
      {
        id: 5,
        type: "link",
        label: "Property Managers",
        link: "/property-managers",
      },
      {
        id: 3,
        type: "link",
        label: "Vendors",
        link: "/vendors",
      },
    ],
  };

  return (
    <div style={styles.root}>
      <div style={styles.mainContainer}>
        {!isCompletedStep && <ResponsiveAppBar navItems={navItems} />}

        <Box>
          <Outlet />
        </Box>
        {location.pathname !== "/post-job" &&
          location.pathname !== "/vendor-onboarding" && <Footer />}
      </div>
    </div>
  );
};

export default MainPageLayout;
